import { render, staticRenderFns } from "./ExpandTransition.vue?vue&type=template&id=0e066b0c&"
import script from "./ExpandTransition.vue?vue&type=script&lang=js&"
export * from "./ExpandTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports